<div class="main">
  <div class="heading">
    <h6>Okay Category</h6>
  </div>
  <div class="graph">
    <div
      echarts
      [options]="gaugeOption"
      [initOpts]="{ renderer: 'canvas' }"
      class="demo-chart"
    ></div>
  </div>
</div>
